import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "@mui/material";

import {
    PageButtonsContainer,
    PageContainer,
    PageHeaderContainer,
    PageLogoContainer,
    PageTitleContainer,
    PageContentContainer,
    DesktopOnly
} from "components/controls";

import { Button, Spacer } from "tm-controls";
import { PageMetadata } from "components/page-metadata";
import { PageFooter } from "components/page-footer";
import { InternalServerErrorDialogProps } from "./internal-server-error-dialog-props";
import { Page } from "components/page";

export const InternalServerErrorDialog = ({
    acklowledgeError
}: InternalServerErrorDialogProps) => {

    const intl = useIntl();
    const logoPath: string = intl.formatMessage({
        id: "application.logo"
    });

    return (
        <Page>
            <PageMetadata />
            <PageContainer>
                <PageHeaderContainer>
                    <PageLogoContainer>
                        <img data-testid="application-logo" height="28px" src={logoPath} alt="logo" />
                    </PageLogoContainer>
                    <PageTitleContainer>
                        <Typography data-testid="internal-server-error-title" variant="h5">
                            <FormattedMessage id="internal.server.error.title" />
                        </Typography>
                    </PageTitleContainer>
                </PageHeaderContainer>
                <PageContentContainer>
                    <Typography data-testid="internal-server-error-message" variant="subtitle2">
                        <FormattedMessage id="internal.server.error.message" />
                    </Typography>
                </PageContentContainer>
                <PageButtonsContainer>
                    <DesktopOnly>
                        <Spacer />
                    </DesktopOnly>
                    <Button
                        data-testid="submit-button"  
                        variant="Filled"
                        color="primary" 
                        onClick={acklowledgeError}
                    > 
                        <FormattedMessage id="internal.server.error.button.text" />
                    </Button>
                </PageButtonsContainer>
            </PageContainer> 
             <PageFooter /> 
        </Page>
    )
}




